module.exports = __webpack_public_path__ + "static/media/specialization-future.a34e1fd7.png";